import { getAppType } from '@/lib/analytics/legacy-sender-context';
import { AppType, type CreationPlatform } from '@/types';
import { AppRecordingSource, DesktopAppType, WebAppType } from '@heidi/schema/ml-scribe';

/**
 * Builds the `creation_platform` object for `POST /api/v2/ml-scribe/sessions/`.
 * `getAppType()` only ever resolves to `Web` or `Desktop` in this client
 * (web + Tauri desktop), so only those two platform types are produced.
 */
export const getSessionCreationPlatform = ({
  isHardware,
}: {
  isHardware: boolean;
}): CreationPlatform => {
  const recording_source = isHardware
    ? AppRecordingSource.Remote
    : AppRecordingSource.Native;

  return getAppType() === AppType.Desktop
    ? { type: DesktopAppType.Desktop, recording_source }
    : { type: WebAppType.Web, recording_source };
};
